// Enum типи для API взаємодії (відповідають Prisma enum з бекенду)

/**
 * Тип відповіді для Apps
 */
export enum ResponseType {
  JSON = 'JSON',
  REDIRECT = 'REDIRECT',
  RENDER = 'RENDER',
}

/**
 * Статус статичного сайту
 */
export enum StaticSiteStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  CREATED = 'CREATED',
  DEPLOYED = 'DEPLOYED',
}

/**
 * Статус застосунку
 */
export enum AppStatus {
  DRAFT = 'DRAFT',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

/**
 * Статус деплою
 */
export enum DeploymentStatus {
  DEPLOYING = 'DEPLOYING',
  DEPLOYED = 'DEPLOYED',
  INACTIVE = 'INACTIVE',
}

/**
 * Роль користувача (read-only для фронтенду)
 */
export enum UserRole {
  USER = 'USER',
  ADMIN = 'ADMIN',
}

/**
 * Рівень логування (read-only для фронтенду, приймається від worker)
 */
export enum LogLevel {
  INFO = 'INFO',
  WARNING = 'WARNING',
  ERROR = 'ERROR',
}
